import React from 'react';
import styled from 'styled-components/macro';

export const HeroLoading = ({ isCategory }) => {
  return (
    <Loading isCategory={isCategory}>
      <LoadingImgContainer>
        <LoadingImg></LoadingImg>
      </LoadingImgContainer>
      <LoadingTextContainer>
        <LoadingText width={20}></LoadingText>
        <LoadingText width={100}></LoadingText>
        <LoadingText width={80}></LoadingText>
      </LoadingTextContainer>
    </Loading>
  );
};

const Loading = styled.div`
  display: flex;
  padding-top: 20px;
  ${(props) =>
    props.isCategory &&
    `
    @media screen and (min-width: 1920px) {
      margin: auto;
      max-width: 1595px;
    }
  `}
`;

const LoadingImgContainer = styled.div`
  margin-right: 20px;
  max-width: 200px;
  width: 25%;
`;

const LoadingImg = styled.div`
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
  border-radius: 8px;
  height: 0;
  padding-bottom: 150%;
  width: 100%;
`;

const LoadingTextContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: end;
  max-width: 500px;
  padding: 0 20px 24px 0;
`;

const LoadingText = styled.div`
  border-radius: 4px;
  height: 24px;
  margin-top: 24px;
  width: ${(props) => props.width}%;
  ${(props) =>
    props.theme.name === 'light'
      ? `background: ${props.theme.color.black5}`
      : `background: ${props.theme.color.white5}`};
`;
